// Enums specific to Works
export enum WorkRoyaltyEntityEnum {
  ECAD = 'ECAD',
  ABRAMUS = 'ABRAMUS',
  ABRAMUS_DIGITAL = 'ABRAMUS_DIGITAL',
}

export enum WorkReleaseTypeEnum {
  ALBUM = 'ALBUM',
  SINGLE = 'SINGLE',
  EP = 'EP',
}

export enum AssociatedTrackStatusEnum {
  READY = 'READY',
  IN_INSPECTION = 'IN_INSPECTION',
  PROCESSING = 'PROCESSING',
  SCHEDULED_TO_DROP = 'SCHEDULED_TO_DROP',
  FAILED = 'FAILED',
}

export enum WorkPublishingStatusEnum {
  INACTIVE = 'INACTIVE',
  ACTIVE = 'ACTIVE',
  REGISTRATION_IN_PROGRESS = 'REGISTRATION_IN_PROGRESS',
  WORK_REGISTRATION_IN_PROGRESS = 'WORK_REGISTRATION_IN_PROGRESS',
  WORK_REGISTRATION_FAILED = 'WORK_REGISTRATION_FAILED',
  UPDATE_IN_PROGRESS = 'UPDATE_IN_PROGRESS',
  UPDATE_FAILED = 'UPDATE_FAILED',
}

// Main Response Interface
export interface GetWorkV2Find {
  timestamp: Date;
  status: string;
  data: GetWorkV2FindData;
  error: {
    error: string;
    title: string;
    code: string;
    trace: string;
    modal: boolean;
  };
  errors: [
    {
      error: string;
      title: string;
      code: string;
      trace: string;
      modal: boolean;
    },
  ];
  page: number;
  metadata: {
    additionalProp1: any;
    additionalProp2: any;
    additionalProp3: any;
  };
  total_pages: number;
  per_page: number;
  total_items: number;
}

// Params Interface
export interface GetWorkV2FindParams {
  page: number;
  size: number;
  sort?: string;
  search?: string;
  creationDateStart?: string;
  creationDateEnd?: string;
}

// Data Interface
export interface GetWorkV2FindData {
  totalPages: number;
  totalElements: number;
  size: number;
  content: GetWorkV2FindItem[];
  number: number;
  sort: {
    empty: boolean;
    sorted: boolean;
    unsorted: boolean;
  };
  numberOfElements: number;
  pageable: {
    offset: number;
    sort: {
      empty: boolean;
      sorted: boolean;
      unsorted: boolean;
    };
    pageNumber: number;
    pageSize: number;
    paged: boolean;
    unpaged: boolean;
  };
  first: boolean;
  last: boolean;
  empty: boolean;
}

// Society Registration Interface
export interface SocietyRegistration {
  royaltyEntity: WorkRoyaltyEntityEnum;
  cwrId: string;
}

// Genre Interface
export interface WorkGenre {
  id: number;
  name: string;
}

// Label Interface
export interface WorkLabel {
  id: number;
  imageId: string;
  name: string;
  description: string;
}

// Associated Track Interface
export interface AssociatedTrack {
  id: number;
  isrc: string;
  hash: string;
  title: string;
  titleVersion: string;
  primaryGenre: WorkGenre;
  secondaryGenre: WorkGenre;
  label: WorkLabel;
  releaseDate: string;
  artistNames: string;
  releaseType: WorkReleaseTypeEnum;
  status: AssociatedTrackStatusEnum;
}

// Rights Sale Status Interface
export interface RightsSaleStatus {
  total: number;
  ready: number;
  inInspection: number;
  processing: number;
  scheduledToDrop: number;
  primaryMarket: number;
  secondaryMarket: number;
  failed: number;
  sales: any[];
  status: string | null;
}

// Publishing Execution Interface
export interface PublishingExecution {
  cwrId: string | null;
  royaltyEntity: WorkRoyaltyEntityEnum;
  iconUrl: string;
  scope: string;
  status: WorkPublishingStatusEnum;
  lastUpdateAt: string;
}

// Publishing Streaming Interface
export interface PublishingStreaming {
  cwrId: string | null;
  royaltyEntity: WorkRoyaltyEntityEnum;
  scope: string;
  status: WorkPublishingStatusEnum;
  lastUpdateAt: string;
}

// Publishing Status Interface
export interface PublishingStatus {
  execution: PublishingExecution[];
  streamingPublishingShare: PublishingStreaming[];
  status: WorkPublishingStatusEnum;
}

// Work Item Interface
export interface GetWorkV2FindItem {
  id: number;
  title: string;
  composerNames: string;
  societyRegistrations: SocietyRegistration[];
  iswc: string;
  explicit: boolean;
  associatedTracks: AssociatedTrack[];
  rightsSaleStatus: RightsSaleStatus;
  publishingStatus: PublishingStatus;
}
